import { PlusTierList } from "@ugg/shared/components/SummonerProfiles/plus-tier-list/PlusTierList";

export function SummonerProfilePlusTierListPage() {
  return (
    <div className="w-[1016px] max-md:w-full">
      <PlusTierList />
    </div>
  );
}
